<div
  [ngClass]="errorState || error ? 'idp-form-grouped--error' : ''"
  class="idp-form-grouped"
>
  <idp-action-label
    (clicked)="notify('top')"
    (iconClicked)="iconClicked()"
    *ngIf="topLabelText"
    [emphasis]="hasValue ? 'dark' : ''"
    [icon]="topLabelIcon"
    [labelId]="topLabelText"
    [ngClass]="open || focused ? 'idp-autocomplete__moveTop' : ''"
    [role]="open || focused ? 'selected' : 'action'"
    [text]="topLabelText"
    class="idp-autocomplete__label idp-autocomplete__label--top"
  ></idp-action-label>

  <div
    (focusin)="dropdownWrapperChangeFocused(true)"
    (keydown.arrowDown)="updateSelection($event, 'down')"
    (keydown.arrowUp)="updateSelection($event, 'up')"
    (keydown.enter)="makeItemSelection($event)"
    (keydown.esc)="close(); refocus()"
    (keydown.shift.tab)="manageFocus()"
    (keydown.tab)="makeItemSelection($event, false)"
    [attr.aria-describedby]="'idp-' + id + '__selected' + ' ' + id + '-desc'"
    [attr.aria-label]="
      topLabelText
        ? topLabelText
        : selectedItem
        ? selectedItem
        : placeholderText
    "
    [id]="id ? id + '-container' : ''"
    [ngClass]="{
      'idp-autocomplete--error': errorState || error,
      'idp-autocomplete--disabled': disabled,
      'idp-autocomplete__add-margin': addMargin
    }"
    [style.bottom]="fixByBottom"
    class="idp-autocomplete"
    data-test-autocomplete="true"
  >
    <div aria-hidden="true" aria-live="off">
      <idp-error-tooltip
        *ngIf="focused && (errorState || error)"
        [arrowPosition]="arrowPosition"
        [errorMessage]="errorMessage"
        [formCtrlId]="id"
        [icon]="true"
        data-test-error-tooltip="true"
      ></idp-error-tooltip>
    </div>
    <span
      *ngIf="focused && submitAttempt && (errorState || error)"
      aria-atomic="true"
      aria-live="polite"
      class="sr-only"
      role="alert"
    >
      {{ errorMessage }}
    </span>
    <idp-input
      (isFocused)="setFocused($event)"
      (keydown)="allowKeydown($event)"
      (value)="inputValue($event)"
      (wasTabbed)="setValueOnTab($event)"
      [addMargin]="addMargin"
      [ariaLabel]="ariaLabel"
      [attr.disabled]="disableOrEnable()"
      [defaultValue]="recursiveLabel"
      [disableFocus]="disableFocus"
      [disabled]="disabled"
      [errorMessage]="errorMessage"
      [errorMessages]="errorMessages"
      [helpModal]="helpModal"
      [hideBottomBorder]="submitAttempt && (errorState || error)"
      [id]="id"
      [labelTxt]="labelTxt"
      [placeholderText]="placeholderText"
      [showFormGrouped]="false"
      [submitAttempt]="submitAttempt"
    ></idp-input>

    <ul
      [attr.aria-label]="
        topLabelText
          ? topLabelText
          : selectedItem
          ? selectedItem.value
          : placeholderText
      "
      [attr.disabled]="disabled"
      [attr.disabled]="disableOrEnable()"
      [attr.aria-labelledby]="id"
      [id]="id + '-desc'"
      [ngClass]="open ? 'idp-autocomplete__open' : ''"
      class="idp-autocomplete__list"
      role="listbox"
      tabindex="-1"
    >
      <ng-container *ngFor="let item of items; let i = index">
        <li
          (focusin)="liChangeFocus(true)"
          (focusout)="liChangeFocus(false)"
          (keydown.tab)="toggle($event, true)"
          (mousedown)="selected($event)"
          [attr.aria-selected]="i === selectedItemIndex ? 'true' : 'false'"
          [attr.data-label]="item?.label"
          [attr.data-value]="item?.value"
          [attr.data]="i"
          [id]="id + '_option-' + (i + 1)"
          [innerHTML]="
            item?.label || ''
              | replace : selectedItem?.value || '' : '<b>' : '</b>'
          "
          [ngClass]="i === selectedItemIndex ? 'active' : ''"
          class="idp-autocomplete__list-item"
          role="option"
          tabindex="-1"
        ></li>
      </ng-container>
      <span *ngIf="open" aria-atomic="true" aria-live="polite" class="sr-only">
        {{ items?.length }} options are available
      </span>
    </ul>
  </div>
  <idp-action-label
    (clicked)="notify('bottom')"
    (iconClicked)="iconClicked()"
    *ngIf="bottomLabelText"
    [icon]="bottomLabelIcon"
    [text]="bottomLabelText"
    class="idp-autocomplete__label idp-autocomplete__label--bottom"
    role="action"
  ></idp-action-label>
</div>
